import { Router } from '@angular/router';
import { TogetherHeaderLink, TogetherHeaderLinks, TogetherCurrentPage } from './models/app.models';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'together-main',
    templateUrl: './together.main.html',
    standalone: false
})
export class TogetherMainComponent {

  /**
   * Current routed URL.
   *
   * @type {string}
   * @memberof TogetherHeaderComponent
   */
  current_url: string;

  /**
   * The current page.
   */
  @Input() page: TogetherCurrentPage;

}
